import axios from 'config/axios';

const prefix = 'cars';

export default class CarsSrv {
  static getForGrid(dataState) {
    return axios
      .post(`${prefix}/getForGrid`, dataState)
      .then(result => result.data);
  }

  static get(id) {
    return axios.get(`${prefix}/${id}`).then(result => result.data);
  }

  static add(model) {
    return axios.post(prefix, model);
  }

  static update(model) {
    return axios.put(prefix, model);
  }

  static getCarTypesAsSelectItem() {
    return axios
      .get(`${prefix}/getCarTypesAsSelectItem`)
      .then(result => result.data);
  }
}
